import React, { Component } from "react";
import { Icon, Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import settings from "../../settings";

class SearchSubTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: props.searchTypeIndex,
    };
  }

  state = { activeIndex: 0 };

  componentWillReceiveProps = (nextProps) => {
    if (this.state.activeIndex !== nextProps.searchTypeIndex)
      this.setState({ activeIndex: nextProps.searchTypeIndex });
  };

  handleClick = (e, index, menuId) => {
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.props.onSearchTypeChanged(e, newIndex, menuId);
  };

  render() {
    const items = [];
    const pathTokens =
      this.props.history.location.pathname &&
      this.props.history.location.pathname.split("/");
    const { acctTheme, currentReportId, currentReportRemainingCount } = this.props;

    const leftMenuThemeClass = acctTheme === 0 ? "left-menu-unselected" : "";
    _.map(this.props.leftMenuItems, (leftMenuItem, index) => {
      const report = _.find(
        this.props.reports,
        (a) => a.ReportID === leftMenuItem.ReportId
      );
      let searchResultCost = report.SearchResultCost;
      if (report.NumberRemaining > 0)
        searchResultCost = "Free";
      let remainingCount = report.NumberRemaining;
      if(currentReportId === report.ReportID && currentReportRemainingCount > 0)
        remainingCount = currentReportRemainingCount;
      const isSelectedTab =
        pathTokens &&
        pathTokens.length > 4 &&
        parseInt(decodeURIComponent(pathTokens[5]), 10) === leftMenuItem.MenuId;
      let titleClass = isSelectedTab ? "left-menu-selected" : leftMenuThemeClass;
      if (acctTheme === 0) {
        titleClass = `${titleClass} classic-left-menu-title`;
      }
      items.push(
        <div
          key={`LeftMenu_${leftMenuItem.MenuTitle}_${leftMenuItem.ReportId}`}
          className={acctTheme === 0 ? "classic-left-menu margin-bottom-20" : ""}
        >
          <Accordion.Title
            active={acctTheme === 0 || this.state.activeIndex === index}
            key={`${leftMenuItem.MenuTitle}Title`}
            onClick={(e) => this.handleClick(e, index, leftMenuItem.MenuId)}
            className={
              titleClass
            }
          >
            <Table className="activeleftmenu table-no-border table-no-padding">
              <Table.Body>
                <Table.Row>
                  <Table.Cell className={"float-left table-no-padding"}>
                    {isSelectedTab && acctTheme === 0 ? (
                      <Icon name="star" />
                    ) : (
                      <Icon name="dropdown" />
                    )}
                    {leftMenuItem.MenuTitle}
                  </Table.Cell>
                  <Table.Cell className={"float-right table-no-padding"}>
                    {(searchResultCost === "Free" || searchResultCost === "$0.00") 
                      && settings.hideNoChargePriceReportIds.includes(leftMenuItem.ReportId) ? "" : searchResultCost}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Accordion.Title>
          <Accordion.Content
            key={`LeftMenuDesc_${leftMenuItem.MenuTitle}`}
            active={acctTheme === 0 || this.state.activeIndex === index}
          >
            {report ? (
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: report.ReportDescription }}
              />
            ) : null}
            {remainingCount >= 0 && remainingCount < 10
              && (<span style={{ color: "red" }}>Remaining free searches - {remainingCount === -1 ? 0 : remainingCount}</span>)}
            {remainingCount >= 10
              && (<span style={{ color: "blue" }}>Remaining free searches - {remainingCount}</span>)}
          </Accordion.Content>
        </div>
      );
    });
    return acctTheme === 0 ? (
      <div className="search-sub-types">
        {items}
      </div>
    ) : (
      <Accordion fluid styled className="search-sub-types">
        {items}
      </Accordion>
    );
  }
}

export default SearchSubTypes;



// WEBPACK FOOTER //
// ./src/components/searches/SearchSubTypes.js